// Web Audio beep — funciona em celular e desktop, sem asset externo.
let ctx = null;

function ensureCtx() {
  if (typeof window === "undefined") return null;
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    ctx = new AC();
  }
  if (ctx.state === "suspended") ctx.resume().catch(() => {});
  return ctx;
}

function tone(freq, dur, type = "square", gain = 0.12) {
  const c = ensureCtx();
  if (!c) return;
  try {
    const o = c.createOscillator();
    const g = c.createGain();
    o.type = type;
    o.frequency.value = freq;
    g.gain.setValueAtTime(gain, c.currentTime);
    g.gain.exponentialRampToValueAtTime(0.0001, c.currentTime + dur);
    o.connect(g);
    g.connect(c.destination);
    o.start();
    o.stop(c.currentTime + dur);
  } catch { /* ignore */ }
}

// Bip curto de sucesso (estilo caixa de mercado)
export function beepSuccess() {
  tone(1180, 0.09, "square", 0.14);
}

// Som grave de erro (código não encontrado)
export function beepError() {
  tone(220, 0.22, "sawtooth", 0.16);
}

// Desbloqueia o áudio no primeiro gesto do usuário (necessário em iOS/Safari)
export function primeAudio() {
  ensureCtx();
}
